import { render, staticRenderFns } from "./myEditor.vue?vue&type=template&id=71515671&scoped=true&"
import script from "./myEditor.vue?vue&type=script&lang=js&"
export * from "./myEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71515671",
  null
  
)

export default component.exports